import React from 'react';
import styled from 'styled-components';

type SvgBracketProps = {
  width?: number;
  height?: number;
  rotation?: number;
};

const Bracket = ({ width = 46, height = 46, rotation = 0 }: SvgBracketProps): JSX.Element => (
  <Icon rotation={rotation}>
    <svg width={width} height={height} viewBox='0 0 46 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <title>Bracket Icon</title>
      <path d='M3 43V17.43C3 9.46 9.46 3 17.43 3H43' stroke='#00A47C' strokeWidth='6' strokeLinecap='round' />
    </svg>
  </Icon>
);

export default Bracket;

const Icon = styled.div<{ rotation?: number }>`
  transform: rotate(${({ rotation }) => rotation}deg);
`;
